import { render, staticRenderFns } from "./printBatchRecord.vue?vue&type=template&id=1fa8da28&"
import script from "./printBatchRecord.vue?vue&type=script&lang=js&"
export * from "./printBatchRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports